import React from 'react';
import {TableRequestColumn, MediaBadge, ButtonWrapper, RequestColumn} from './styles';
import {InputCheckbox, RequestButton} from '..';
import Media from '../Media/Media';

export default ({
  age,
  name,
  email,
  imgUrl,
  checked,
  position,
  callback,
  onCheckbox,
  invitationID,
  team,
  status,
  invitationType,
}: {
  age: string;
  name: string;
  email: string;
  imgUrl: string;
  callback?: any;
  onCheckbox?: any;
  position: string;
  checked?: boolean;
  invitationID?: any;
  team?: any;
  status?: string;
  invitationType?: string;
}) => (
  <>
    <TableRequestColumn>
      <MediaBadge>
        {(status === "Pending" && invitationType !== "Request") && 
          (
            <InputCheckbox onClick={onCheckbox} checked={checked || false} />
          )
        }
        
        <Media imgUrl={imgUrl} name={name} />
      </MediaBadge>
    </TableRequestColumn>
    <TableRequestColumn>{email}</TableRequestColumn>
    <TableRequestColumn>
      {team?.map((item, idx) => {
        if (idx === team?.length - 1) {
          return <span key={item.name}>{item?.name}</span>;
        } else {
          return <span key={item.name}>{item?.name + ', '}</span>;
        }
      })}
    </TableRequestColumn>
    <TableRequestColumn>{status}</TableRequestColumn>
    <RequestColumn colSpan={5} theme={'strong'}>
      <span style={{display: 'inline-block', verticalAlign: 'center', lineHeight: 'normal', margin: '5px 0px 5px 0px'}}>
        Awaiting your reply to assign them to a team:
      </span>
      <ButtonWrapper>
        <RequestButton
          title="ACCEPT"
          lColor="var(--SecondaryBlue);"
          rColor="var(--PrimaryBlue);"
          icon="thumbsUp"
          xMargin="0 10px 0 15px"
          callback={() => callback(invitationID, 'accept')}
        />
        <RequestButton
          title="REJECT"
          rColor="#FF3B30"
          lColor="#E1342A"
          icon="thumbsDown"
          xMargin="0 10px 0 15px"
          callback={() => callback(invitationID, 'decline')}
        />
      </ButtonWrapper>
    </RequestColumn>
  </>
);
